// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEffect } from "effector";
import {
  SurveyDatesWriteRequestDTO,
  SurveyInfoResponseDTO,
  SurveyResultsResponseDTO,
  SurveySearchRequestDTO,
  SurveysListInfoResponseDTO,
  SurveyWorkflowRequestDTO,
  SurveyWriteRequestDTO
} from "../../api/backend-openapi";
import "whatwg-fetch";
import configuration from "../../utils/Config";
import {
  restCreationHandler,
  restDatesUpdateHandler,
  restDeletionHandler,
  restDetailsHandler,
  restDuplicationHandler,
  restListHandlerPagination,
  restUpdateHandler,
  restWorkflowHandler
} from "../../utils/rest/RestClient";

const baseUrl = configuration.backendBaseUrl;
const surveyUrl = baseUrl + "/survey/";

export const requestGetSurveysList = createEffect({
  handler: restListHandlerPagination<
    SurveySearchRequestDTO,
    SurveysListInfoResponseDTO
  >(surveyUrl + "search")
});
export const requestGetSurvey = createEffect({
  handler: restDetailsHandler<SurveyInfoResponseDTO>(surveyUrl)
});
export const requestGetSurveyResults = createEffect({
  handler: restDetailsHandler<SurveyResultsResponseDTO>(surveyUrl + "results/")
});
export const requestCreateSurvey = createEffect({
  handler: restCreationHandler<SurveyWriteRequestDTO, SurveyInfoResponseDTO>(
    surveyUrl
  )
});
export const requestDuplicateSurvey = createEffect({
  handler: restDuplicationHandler<SurveyInfoResponseDTO>(surveyUrl)
});
export const requestUpdateSurvey = createEffect({
  handler: restUpdateHandler<SurveyWriteRequestDTO, SurveyInfoResponseDTO>(
    surveyUrl
  )
});
export const requestDatesUpdateSurvey = createEffect({
  handler: restDatesUpdateHandler<
    SurveyDatesWriteRequestDTO,
    SurveyInfoResponseDTO
  >(surveyUrl)
});
export const requestDeleteSurvey = createEffect({
  handler: restDeletionHandler<SurveyInfoResponseDTO>(surveyUrl)
});
export const requestWorkflowSurvey = createEffect({
  handler: restWorkflowHandler<SurveyWorkflowRequestDTO, SurveyInfoResponseDTO>(
    surveyUrl
  )
});
